import 'antd-mobile/es/global'
import React from 'react'
import ReactDOM from 'react-dom/client'
import Router from '@/router/index'

// import BrowserLogger from '@arms/js-sdk'
// 引入图标注册
import 'virtual:svg-icons-register'
import { ENV, getEnvironment } from './env'
import { activityApiDecorator } from './apis/activity'
import { indexApiDecorator } from './apis'

if (ENV.VITE_APP_API_ENV !== 'prod') {
  console.log('ENV:',ENV);
  console.log('getEnvironment:',getEnvironment());
}



// const config = {
//   pid: 'g7ce2nvp0x@48d47b0df788fca',
//   appType: 'web',
//   imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
//   sendResource: true,
//   enableLinkTrace: true,
//   behavior: true,
//   enableSPA: false,
//   environment: getEnvironment(),
//   release: '1.0.1'
// }


// const script = document.createElement('script')
// script.text = `
//   !(function(c,b,d,a){c[a]||(c[a]={});c[a].config=${JSON.stringify(config)};
//   with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
//   })(window,document,"https://sdk.rum.aliyuncs.com/v1/bl.js","__bl");
// `

// cdn外链形式
// const script = document.createElement('script')
// script.text = `
//   !(function(c,b,d,a){c[a]||(c[a]={});c[a]=${JSON.stringify(config)};
//   with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
//   })(window, document, "https://sdk.rum.aliyuncs.com/v2/browser-sdk.js","__rum");
// `
// document.body.insertBefore(script, document.body.firstChild)

// 阿里云前端监控配置 - 暂时关闭：大版本更新可开启查看错误
// const aliyunFEMonitorConfig = {

//   pid: 'gndt3gpkvt@b490dae7d092ee0',
//   appType: 'web',
//   imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
//   sendResource: true,
//   enableLinkTrace: true,
//   behavior: true,
//   environment: getEnvironment()
// }

// BrowserLogger.singleton(aliyunFEMonitorConfig)

// const script2 = document.createElement('script')

// script2.text = `
// !(function(c,b,d,a){c[a]||(c[a]={});c[a].config=${aliyunFEMonitorConfig};
// with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
// })(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");
// `

// document.body.insertBefore(script2, document.body.firstChild)


const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
)

if (getEnvironment() !== 'prod') {
  // qa 环境打包后使用 vconsole 来调试
  const loadVConsole = async() => {
    const VConsole = await import('vconsole')
    // eslint-disable-next-line no-new, new-cap
    new VConsole.default()
  }
  loadVConsole()
}


  // 接口预请求（该方法会在页面加载时执行，用于预请求接口，避免页面加载时接口请求的卡顿， 这里不会处理任何逻辑，只是预请求）
const preRequest = async() => {
  try {
    let adRouteCode = new URLSearchParams(window.location.search).get('adRouteCode') 
    let adChannelCode = new URLSearchParams(window.location.search).get('adChannelCode')
    
    if (!adChannelCode && !adRouteCode) {
      return
    }
    
    if (adRouteCode) {
      const res = await indexApiDecorator.getAdChannelCodeByRouteCodeCache(adRouteCode) || ''
      if (res.adChannelCode) {
        adChannelCode = res.adChannelCode
      }
    }

    if (adChannelCode) {
      const codeDetailRes = await activityApiDecorator.getChannelCodeDetailCache(adChannelCode)
      activityApiDecorator.getH5ConfigCache({ adChannelId: codeDetailRes.id })
    }
  } catch (error) {
    console.error('接口预请求失败', error)
  }

}
preRequest()


root.render(
  // <React.StrictMode>
  // <Provider store={store}>
  <Router />
  // </Provider>
  // </React.StrictMode>
)
